/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { MODIFY_ORDER } from "../graphql/modifyOrder.mutation";

const is = require("is_js");
export interface IModifyOrderArgs {
  boxId: string;
  presentationID: string;
  sectionID: string;
  reason: string;
  items: {
    costumeType: string;
    costumeFeature: string;
    costumeAttribute: string;
    costumeValue: string;
  }[];
}

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IModifyOrderTypeMethods extends IPluginMethodMap {
  modifyOrder(args: any): Promise<any>;
}

export class ModifyOrderService implements IAgentPlugin {
  readonly methods: IModifyOrderTypeMethods;

  constructor() {
    this.methods = {
      modifyOrder: this.modifyOrder.bind(this),
    };
  }

  async modifyOrder(args: IModifyOrderArgs) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    try {
      if (client) {
        const res = await client.mutate({
          mutation: MODIFY_ORDER,
          variables: {
            data: {
              boxId: args?.boxId,
              presentation: args?.presentationID,
              section: args?.sectionID,
              reason: args?.reason,
              items: args?.items,
            },
          },
          fetchPolicy: "no-cache",
        });

        if (res?.data?.modifyOrder && is.existy(res?.data?.modifyOrder)) {
          return res?.data?.modifyOrder;
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
